module.exports = __webpack_public_path__ + "img/expert-bg.0baad67d.png";